var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c("w-multi-select", {
    attrs: {
      value: _vm.selectedValues,
      items: _vm.items,
      label: _vm.label,
      fancy: _vm.fancy,
      light: _vm.light,
      disabled: _vm.disabled,
    },
  })
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }